import React from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow from './StudyListTableRow';
import StudyListCards from './StudyListCards';
import useMediaQuery, { CONSULTA_MOVIL } from '../../utils/useMediaQuery';

const StudyListTable = ({ tableDataSource, querying }) => {
  // PARCHE CABSEN (2026-09-14): por debajo de 768 px (el "md" de Tailwind) la tabla de siete columnas
  // truncadas es ilegible en un telefono; se pinta la lista en tarjetas. Se decide con matchMedia para
  // pintar solo una de las dos presentaciones (nada de DOM duplicado).
  const esMovil = useMediaQuery(CONSULTA_MOVIL);
  if (esMovil) {
    return (
      <StudyListCards
        tableDataSource={tableDataSource}
        querying={querying}
      />
    );
  }
  return (
    <div className="bg-black">
      <div className="container relative m-auto">
        <table className="w-full text-white">
          <tbody
            data-cy="study-list-results"
            data-querying={querying}
          >
            {tableDataSource.map((tableData, i) => {
              return (
                <StudyListTableRow
                  tableData={tableData}
                  key={i}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
};

export default StudyListTable;
